import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
// V1: English only. To enable Arabic, uncomment the next line and the `ar` entry in resources.
// import ar from "./locales/ar.json";

const DEFAULT = process.env.REACT_APP_DEFAULT_LANGUAGE || "en";
const AVAILABLE = (process.env.REACT_APP_AVAILABLE_LANGUAGES || "en")
  .split(",")
  .map((s) => s.trim())
  .filter(Boolean);

// Right-to-left language codes. AR is included so future localisation flips the layout automatically.
export const RTL_LANGUAGES = new Set(["ar", "he", "fa", "ur"]);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      // ar: { translation: ar },
    },
    lng: DEFAULT,
    fallbackLng: "en",
    supportedLngs: AVAILABLE,
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupQuerystring: "lang",
    },
  });

// Sync <html lang/dir> on language change for SEO + RTL readiness.
const applyHtmlAttrs = (lng) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lng;
  document.documentElement.dir = RTL_LANGUAGES.has(lng) ? "rtl" : "ltr";
};
applyHtmlAttrs(i18n.language || DEFAULT);
i18n.on("languageChanged", applyHtmlAttrs);

export default i18n;
